export * from '@core/services/config/config.module';
export * from '@core/services/config/config.service';
